<template>
    <div>
        <div class="d-flex h-100 w-100">
            <div class="col-md-3">
                <ChangingNamePainel @search="dataSearch = $event"></ChangingNamePainel>
            </div>
            <div class="col-md-9">
                <ChangingNameTable :dataSearch="dataSearch"></ChangingNameTable>
            </div>
        </div>
    </div>
</template>

<script>
import ChangingNameBusiness from '../ChangingNameBusiness/ChangingNameBusiness.js'
export default ChangingNameBusiness
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/ChangingNameBusiness/ChangingNameBusiness.vue